@if (visible && concept) {
  <div [class.feedback-target]="feedbackMode.isActive"
       (click)="onConceptSectionClick($event)">
    <div class="fset cl">
      @for (field of classificationFields; track field.oid) {
        <div pub-field-render [field]="field"></div>
      }
      @if (hasRelations) {
        <div class="fset rel f">
          <div class="label" i18n="@@resultView.relations">Relations</div>
          <div class="value">
            <pub-render-relations [conceptId]="concept.id" [textComponent]="true"
                                  (conceptSelected)="selectConcept($event)"></pub-render-relations>
          </div>
        </div>
      }
      @if (conceptFields?.length) {
        @for (field of conceptFields; track field.oid) {
          <div pub-field-render [field]="field"
               (conceptSelected)="selectConcept($event)"></div>
        }
      }
    </div>
  </div>
}
